import { render, staticRenderFns } from "./roleClearTable.vue?vue&type=template&id=0335ca30&"
import script from "./roleClearTable.vue?vue&type=script&lang=js&"
export * from "./roleClearTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0335ca30')) {
      api.createRecord('0335ca30', component.options)
    } else {
      api.reload('0335ca30', component.options)
    }
    module.hot.accept("./roleClearTable.vue?vue&type=template&id=0335ca30&", function () {
      api.rerender('0335ca30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/roleClearTable.vue"
export default component.exports